import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Banner = ({ position, className = '' }) => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/banners?position=${position}`);
        setBanners(response.data || []);
      } catch (error) {
        console.log('No banners available');
      }
    };
    fetchBanners();
  }, [position]);

  if (banners.length === 0) return null;

  // Para posição hero ou featured, pegar apenas 1 banner
  const isFeatured = position.includes('hero') || position.includes('featured');
  const displayBanners = isFeatured ? [banners[0]] : banners;

  return (
    <div className={className}>
      {displayBanners.map((banner) => (
        <BannerItem key={banner.id} banner={banner} isFeatured={isFeatured} />
      ))}
    </div>
  );
};

const BannerItem = ({ banner, isFeatured }) => {
  const content = (
    <div 
      className={`relative overflow-hidden rounded-xl shadow-lg transition-transform hover:scale-[1.02] ${
        isFeatured ? 'h-48 md:h-64' : 'h-32 md:h-40'
      }`}
    >
      <img 
        src={banner.image} 
        alt={banner.title}
        className="w-full h-full object-cover"
      />
      {/* Overlay gradiente */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
      
      {/* Título */}
      <div className="absolute bottom-4 left-4 right-4">
        <h3 className={`text-white font-black drop-shadow-lg ${isFeatured ? 'text-xl md:text-2xl' : 'text-lg'}`}>
          {banner.title}
        </h3>
      </div>
    </div>
  );

  if (banner.link) {
    if (banner.link.startsWith('http')) {
      return (
        <a href={banner.link} target="_blank" rel="noopener noreferrer" className="block">
          {content}
        </a>
      );
    }
    return (
      <Link to={banner.link} className="block">
        {content}
      </Link>
    );
  }

  return content;
};

// Componente para múltiplos banners lado a lado
export const BannerGrid = ({ position, columns = 2, className = '' }) => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/banners?position=${position}`);
        setBanners(response.data || []);
      } catch (error) {
        console.log('No banners available');
      }
    };
    fetchBanners();
  }, [position]);

  if (banners.length === 0) return null;

  return (
    <div className={`grid grid-cols-1 md:grid-cols-${columns} gap-4 ${className}`}>
      {banners.map((banner) => (
        <BannerItem key={banner.id} banner={banner} isFeatured={false} />
      ))}
    </div>
  );
};
